import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogTitle, IconButton, LinearProgress, Stack, Typography } from '@mui/material';
import { Close, Download, OpenInNew } from '@mui/icons-material';
import getFileURL from 'app/repository/getFileURL';
import startDownload from './startDownload';

const reportKey = (file) => `reports/${file}`;

const VIEWER_OPTIONS = '#navpanes=0&pagemode=none';

const DocumentViewerDialog = ({ open, onClose, title, subtitle, file }) => {
    const [url, setUrl] = useState();
    const [error, setError] = useState();

    useEffect(() => {
        if (!open || !file) return undefined;
        let cancelled = false;
        setUrl(undefined);
        setError(undefined);
        getFileURL(reportKey(file), false, null, true, true)
            .then((signedUrl) => !cancelled && setUrl(signedUrl))
            .catch((err) => !cancelled && setError(err.message));
        return () => {
            cancelled = true;
        };
    }, [open, file]);

    const handleDownload = async () => {
        try {
            const downloadUrl = await getFileURL(reportKey(file), true, `${title}.pdf`, true);
            startDownload(downloadUrl);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth PaperProps={{ sx: { height: '90vh' } }}>
            <DialogTitle component="div" sx={{ display: 'flex', alignItems: 'center', gap: 2, borderBottom: 1, borderColor: 'divider' }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="h6" noWrap>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="body2" color="text.secondary" noWrap>
                            {subtitle}
                        </Typography>
                    )}
                </Box>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" size="small" startIcon={<OpenInNew />} disabled={!url} onClick={() => window.open(url, '_blank')}>
                        Open in new tab
                    </Button>
                    <Button variant="contained" size="small" startIcon={<Download />} disabled={!url} onClick={handleDownload}>
                        Download
                    </Button>
                </Stack>
                <IconButton aria-label="Close" onClick={onClose}>
                    <Close />
                </IconButton>
            </DialogTitle>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', bgcolor: 'grey.100' }}>
                {!url && !error && <LinearProgress />}
                {error && (
                    <Typography color="error" sx={{ p: 3 }}>
                        {error}
                    </Typography>
                )}
                {url && <Box component="iframe" title={title} src={`${url}${VIEWER_OPTIONS}`} sx={{ flex: 1, width: '100%', border: 0 }} />}
            </Box>
        </Dialog>
    );
};

export default DocumentViewerDialog;
